// Polyfills básicos para React 18
// TEMPORALMENTE SIMPLIFICADO para evitar conflictos

// Control de logs por variable de entorno (se ejecuta lo antes posible)
const __enableConsole = !(import.meta.env?.VITE_ENABLE_CONSOLE === 'false' || import.meta.env?.VITE_ENABLE_CONSOLE === '0');
if (!__enableConsole) {
  const __noop = () => {};
  console.log = __noop;
  console.info = __noop;
  console.debug = __noop;
}

console.log('✅ Polyfills básicos cargados - React 18 compatible'); 

// --- Mejora global: sincronizar cambios de orientación en Android PWA ---
// Problema: En algunas tablets Android en modo standalone (PWA), el evento 'resize'
// puede no dispararse de forma confiable al cambiar de orientación.
// Solución: Escuchar múltiples señales de cambio de orientación/viewport y despachar
// manualmente un 'resize' + actualizar una variable CSS '--app-vh' basada en visualViewport.
(function setupViewportOrientationSync() {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  let lastW = window.innerWidth;
  let lastH = window.innerHeight;
  let rafPending = false;

  const updateVhVar = () => {
    const vh = (window.visualViewport?.height ?? window.innerHeight) * 0.01;
    document.documentElement.style.setProperty('--app-vh', `${vh}px`);
  };

  const dispatchViewportChange = () => {
    // Evitar tormenta de eventos; colapsar en un frame
    if (rafPending) return;
    rafPending = true;
    requestAnimationFrame(() => {
      rafPending = false;
      updateVhVar();
      // Forzar notificación a listeners existentes en la app
      window.dispatchEvent(new Event('resize'));
      // Evento custom por si se quiere escuchar explícitamente
      window.dispatchEvent(new Event('app:viewport-change'));
      lastW = window.innerWidth;
      lastH = window.innerHeight;
    });
  };

  const maybeDispatchOnSizeChange = () => {
    const w = window.innerWidth;
    const h = window.innerHeight;
    if (w !== lastW || h !== lastH) {
      dispatchViewportChange();
    } else {
      // Igual actualizamos la variable vh por si solo cambió el viewport visible
      updateVhVar();
    }
  };

  // Inicialización
  updateVhVar();

  // 1) Resize normal
  window.addEventListener('resize', maybeDispatchOnSizeChange, { passive: true });

  // 2) visualViewport resize (común en Android al rotar en PWA)
  if (window.visualViewport && 'addEventListener' in window.visualViewport) {
    window.visualViewport.addEventListener('resize', dispatchViewportChange, { passive: true });
  }

  // 3) screen.orientation (cuando está disponible)
  const screenOrientation = (window.screen as any)?.orientation;
  if (screenOrientation && typeof screenOrientation.addEventListener === 'function') {
    screenOrientation.addEventListener('change', dispatchViewportChange);
  }

  // 4) orientationchange (legacy, pero útil)
  window.addEventListener('orientationchange', dispatchViewportChange, { passive: true });

  // 5) matchMedia para orientación
  if (window.matchMedia) {
    const mql = window.matchMedia('(orientation: portrait)');
    const mqlHandler = () => dispatchViewportChange();
    if (typeof mql.addEventListener === 'function') {
      mql.addEventListener('change', mqlHandler);
      // Limpieza
      window.addEventListener('beforeunload', () => {
        mql.removeEventListener('change', mqlHandler);
      });
    } else if (typeof (mql as any).addListener === 'function') {
      // Soporte para navegadores antiguos
      (mql as any).addListener(mqlHandler);
      window.addEventListener('beforeunload', () => {
        (mql as any).removeListener(mqlHandler);
      });
    }
  }
})(); 
